import { Mutex } from 'async-mutex';
import { injectable } from 'inversify';
import { MutexKey } from '../constants/mutex';

@injectable()
export default class LocalMutex {
  readonly #mutexMap = new Map<MutexKey, Mutex>();

  async lock(key: MutexKey): Promise<() => void> {
    let mutex = this.#mutexMap.get(key);

    if (!mutex) {
      mutex = new Mutex();
      this.#mutexMap.set(key, mutex);
    }

    if (mutex.isLocked()) {
      await mutex.waitForUnlock();
    }

    return await mutex.acquire();
  }

  isLocked(key: MutexKey): boolean {
    const mutex = this.#mutexMap.get(key);

    if (mutex) {
      return mutex.isLocked();
    }

    return false;
  }

  async waitForUnlock(key: MutexKey): Promise<void> {
    const mutex = this.#mutexMap.get(key);

    if (mutex?.isLocked()) {
      await mutex.waitForUnlock();

      return;
    }

    await Promise.resolve();
  }
}
